<div class="main-content">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">

                <div class="d-sm-flex align-items-center justify-content-between mb-4 margin-bottom">
                    <h1 class="h3 mb-0 text-gray-800">{{name}}</h1>
                    <!--<ng-container *ngIf="accept">-->
                    <a *ngIf="hasId" [routerLink]="['/app/assigned_assessment',from, id, assignmentId, name, {skipLocationChange: true}]" 
                       class="d-none d-sm-inline-block btn btn-sm btn-other shadow-sm readyBtn">
                        <!--<i class="fas fa-arrow-right text-white-50"> <span class="button-text">I'm ready to begin!</span></i>-->
                        <span class="button-text">I'm ready to begin</span><i class="fas fa-caret-right"></i>
                    </a>
                    <a *ngIf="!hasId" [routerLink]="['/app/assigned_assessment',from, assignmentId]" 
                       class="d-none d-sm-inline-block btn btn-sm btn-other shadow-sm readyBtn">
                        <!--<i class="fas fa-arrow-right text-white-50"> <span class="button-text">I'm ready to begin!</span></i>-->
                        <span class="button-text">I'm ready to begin</span><i class="fas fa-caret-right"></i>
                    </a>
                    <!--</ng-container>-->
                    <!--<ng-container *ngIf="!accept">
                <a (click)="showToast()" class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm">
                    <i class="fas fa-arrow-right text-white-50"> <span class="button-text">Begin assessment</span></i>
                </a>
            </ng-container>-->

                </div>

                <div class="card shadow" style="margin:15px 0;">

                    <div *ngIf="from != 'rater'" class="container-fluid">

                        <div>
                            <p>The Energy Leadership&#8482; Index 2.0 (ELI) assessment contains a series of statements for you to answer. For each statement, you'll be asked to indicate the extent to which the statement relates to you, to your perspective on life, and/or to certain aspects of your life.</p>
                            <br />
                            <p>When considering a response, it is important to answer based on how you TYPICALLY or USUALLY think, feel, and/or act. Please do not respond based on how you think, feel, and/or act in any particular current situation, nor on how you would prefer to think, feel, or act.</p>
                            <br />
                            <p>The five possible responses to each statement are:</p>

                            <div class="optionsButtons">
                                <img src="../../../assets/img/c-u-b.png" alt="Alternate Text" />
                                <img src="../../../assets/img/s-u-b.png" alt="Alternate Text" />
                                <img src="../../../assets/img/s-t-b.png" alt="Alternate Text" />
                                <img src="../../../assets/img/v-t-b.png" alt="Alternate Text" />
                                <img src="../../../assets/img/c-t-b.png" alt="Alternate Text" />
                            </div>
                            <p>There are no right or wrong answers. To get the most accurate assessment possible and to subsequently fully benefit from the ELI debrief, it is critically important to answer each question honestly.</p>
                            <p>Do your best to answer each question in how it relates to your life, and generalize to make it appropriate. For example, if a question asks about how you interact with the people at work, and you either work alone or do not work, then answer based on how you interact with people in other areas of your life.</p>
                            <p>Do not rush your rating by responding without carefully reading each question and then giving it due consideration. That said, do not over-think your answers, either. Most often, the first answer that occurs to you is the most accurate.</p>
                            <p>Most people complete the assessment in 20 minutes or less. While taking the assessment, if you are inactive for more than 5 minutes you will be signed out. When you sign back in, you will be taken to the same place you left off.</p>
                        </div>

                        <label><!--I have read and understood all of the instructons. <input (change)="acceptInstructions()" type="checkbox" [(ngModel)]="accept" name="" value="" />--></label>
                        <!--<div class="col-12" style="display:flex;">
                    <div class="checkbox" style="display:contents;">
                        <input [(ngModel)]="accept" (change)="acceptInstructions()" id="checkbox" type="checkbox">
                        <label style="vertical-align: middle;" for="checkbox"></label>
                    </div>
                    <p><b>I have read and understood all of the instructions.</b></p>
                </div>-->

                    </div>
                    <div *ngIf="from == 'rater'" class="container-fluid">
                        <p>Thank you for participating in iPEC's 360 assessment process. </p>

                        <br />

                        <p>Please fill out the following questions with regard to the person you have been asked to rate. We ask that you carefully consider your answers and that you be as honest as possible so that the person being rated can benefit from the process. Your responses will be combined with other responses and represented as an average.</p>
                        
                        <br />

                        <p>Your individual responses and your name are not identified in Feedback Report. If a particular question does not apply because of your relationship to the person you are rating, please leave it blank.</p>
                    </div>
                </div>

            </div>

        </div>
    </div>
</div>
